"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const PulseStageOptions_1 = require("./PulseStageOptions");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const MenuOptions_1 = __importDefault(require("../MenuOptions"));
const selectors_1 = __importDefault(require("../../../reviews-modal/slice/selectors"));
const store_1 = require("../../../reviews-modal/store");
const sliceReview_1 = require("../../../reviews-modal/slice/sliceReview");
const PulseStageSelect = ({ isReadOnly, stageTriggerTypeOptions, index, currentStage, }) => {
    const { roundStages } = (0, react_redux_1.useSelector)(selectors_1.default);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const dispatchUpdateRoundStage = (valueUpdate) => {
        dispatch((0, sliceReview_1.updateRoundStage)({
            indexStage: index,
            valueUpdate,
        }));
    };
    const allStages = roundStages || [];
    const stageTriggerType = (0, react_1.useMemo)(() => {
        var _a;
        const triggerTypeId = (_a = currentStage === null || currentStage === void 0 ? void 0 : currentStage.triggerTypeId) === null || _a === void 0 ? void 0 : _a.toString();
        return (stageTriggerTypeOptions.find((opt) => opt.value.toString() === triggerTypeId) || stageTriggerTypeOptions[0]);
    }, [currentStage === null || currentStage === void 0 ? void 0 : currentStage.triggerTypeId, stageTriggerTypeOptions]);
    const stageOptions = (0, react_1.useMemo)(() => {
        return allStages
            .map((stage, idx) => ({
            label: stage.nameStage,
            prefix: `S${idx + 1}`,
            value: stage.clientId,
            valueName: stage.nameStage,
            stageKey: stage.clientId,
            originalIndex: idx,
        }))
            .filter((opt) => opt.originalIndex !== index);
    }, [allStages, index]);
    const optionsWithIndex = (0, react_1.useMemo)(() => {
        return stageOptions.map((opt, idx) => ({
            ...opt,
            index: idx + 1,
        }));
    }, [stageOptions]);
    const selectedOption = (0, react_1.useMemo)(() => {
        return (stageOptions.find((opt) => {
            const getSelectedByStageKeyOrName = opt.stageKey === (currentStage === null || currentStage === void 0 ? void 0 : currentStage.parentStageId);
            return getSelectedByStageKeyOrName;
        }) || null);
    }, [stageOptions, currentStage]);
    const handleChangeOption = (val) => {
        if (!val || Array.isArray(val))
            return;
        dispatchUpdateRoundStage({
            parentStageId: val.value,
        });
    };
    const handleChangeTriggerStage = (newValue) => {
        dispatchUpdateRoundStage({
            triggerTypeId: Number(newValue.value),
        });
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-select__container'] },
        react_1.default.createElement(pulse_components_1.PulseSelectBase, { options: optionsWithIndex, isDisabled: isReadOnly, dataStructure: null, value: selectedOption, isSearchable: false, hideMenuOnValueChange: true, isMulti: false, classes: {
                menu: {
                    menuCtn: styles_modules_less_1.default['stage-select__menu-list'],
                },
            }, components: {
                SingleValue: PulseStageOptions_1.PulseStageSingleValue,
                // eslint-disable-next-line react/display-name
                Option: (0, react_1.forwardRef)((propsOption, ref) => {
                    const { data, ...basePropsOption } = propsOption;
                    return (react_1.default.createElement(PulseStageOptions_1.PulseStageOptions, { ...basePropsOption, data: data, handleChangeOption: handleChangeOption }));
                }),
            }, variant: "v3" }),
        stageTriggerTypeOptions.length > 0 && (react_1.default.createElement(MenuOptions_1.default, { classes: {
                root: styles_modules_less_1.default['stage-settings__menu'],
                menu: {
                    menuCtn: styles_modules_less_1.default['stage-settings__menuCtn'],
                },
                menuListCustom: styles_modules_less_1.default['stage-settings___menuList'],
            }, value: stageTriggerType, handleChange: handleChangeTriggerStage, options: stageTriggerTypeOptions, isDisabled: isReadOnly, variant: "v3" }))));
};
exports.default = PulseStageSelect;
